webpackJsonp([4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(29);
	
	var _common = __webpack_require__(30);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _hirekListazo = __webpack_require__(282);
	
	var _hirekListazo2 = _interopRequireDefault(_hirekListazo);
	
	var _kapcsolat = __webpack_require__(288);
	
	var _kapcsolat2 = _interopRequireDefault(_kapcsolat);
	
	var _news = __webpack_require__(364);
	
	var _news2 = _interopRequireDefault(_news);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('ANYI-app', [_common2.default, _hirekListazo2.default, _kapcsolat2.default, _news2.default]).constant('environment', window.__env).config(["$locationProvider", function ($locationProvider) {
		'ngInject';
	
		$locationProvider.hashPrefix('');
	}]);
	_angular2.default.bootstrap(document, ['ANYI-app']);

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODULE_NAME = 'hirekService';
	
	var HirekService = function () {
		HirekService.$inject = ["$http", "environment", "$q"];
		function HirekService($http, environment, $q) {
			'ngInject';
	
			_classCallCheck(this, HirekService);
	
			this._$http = $http;
			this._$q = $q;
			this._apiRoot = $http({
				url: environment.backendUrl + '/do/proxy/b'
			});
		}
	
		_createClass(HirekService, [{
			key: 'getKategoriak',
			value: function getKategoriak() {
				var _this = this;
	
				return this._apiRoot.then(function (apiRoot) {
					return apiRoot.$request().$get('hirKategoriak');
				}).then(function (resp) {
					return resp.$hasEmbedded('newsCategories') ? resp.$request().$get('newsCategories') : [];
				}, function () {
					return _this._$q.reject();
				});
			}
		}, {
			key: 'getCimkek',
			value: function getCimkek(size) {
				var _this2 = this;
	
				return this._apiRoot.then(function (apiRoot) {
					return apiRoot.$request().$get('cimkekTop', { page: 0, size: size || 10 });
				}).then(function (resp) {
					return resp.$hasEmbedded('cimkek') ? resp.$request().$get('cimkek') : [];
				}, function () {
					return _this2._$q.reject();
				});
			}
		}, {
			key: 'get',
			value: function get(id) {
				var _this3 = this;
	
				return this._apiRoot.then(function (apiRoot) {
					return apiRoot.$request().$get('hir', { hirId: id });
				}, function () {
					return _this3._$q.reject();
				});
			}
		}, {
			key: 'lista',
			value: function lista(model, type) {
				var _this4 = this;
	
				var searchQueryPagePromise = this._apiRoot.then(function (apiRoot) {
					return apiRoot.$request().$get(type, model);
				}, function () {
					return _this4._$q.reject();
				});
				var searchQueryPromise = searchQueryPagePromise.then(function (resp) {
					return resp.$hasEmbedded('hirek') ? resp.$request().$get('hirek') : [];
				}, function () {
					return _this4._$q.reject();
				});
				return this._$q.all([searchQueryPagePromise, searchQueryPromise]);
			}
		}]);
	
		return HirekService;
	}();
	
	exports.default = angular.module(MODULE_NAME, []).service('hirekService', HirekService).name;

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _hirekListazo = __webpack_require__(283);
	
	var _hirekListazo2 = _interopRequireDefault(_hirekListazo);
	
	var _hirekService = __webpack_require__(279);
	
	var _hirekService2 = _interopRequireDefault(_hirekService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODULE_NAME = 'hirekListazo';
	
	var HirekListazoController = function () {
		HirekListazoController.$inject = ["hirekService", "$sce"];
		function HirekListazoController(hirekService, $sce) {
			'ngInject';
	
			_classCallCheck(this, HirekListazoController);
	
			this._hirekService = hirekService;
			this._$sce = $sce;
		}
	
		_createClass(HirekListazoController, [{
			key: '$onInit',
			value: function $onInit() {
				this.type = this.napokSzama ? 'hirekKategoriaNapokSzamaAlapjan' : 'hirekKategoraAlapjan';
				this.filter = { kategoria: this.kategoria, page: 0, size: this.hirekSzama || 9999 };
				if (this.type) {
					this.filter.napokSzama = this.napokSzama;
				}
				this._getHirek();
			}
		}, {
			key: '_getHirek',
			value: function _getHirek() {
				var _this = this;
	
				this._hirekService.lista(this.filter, this.type).then(function (response) {
					_this.hirek = response[1];
				}, function () {
					_this.technikaiHiba = true;
				});
			}
		}, {
			key: 'getReszletesUrl',
			value: function getReszletesUrl(id) {
				return this.reszletesUrl + '?id=' + id;
			}
		}]);
	
		return HirekListazoController;
	}();
	
	exports.default = angular.module(MODULE_NAME, [_hirekService2.default]).component('hirekListazo', {
		controller: HirekListazoController,
		template: (0, _hirekListazo2.default)(),
		bindings: {
			reszletesUrl: '@',
			hirdobozCim: '@',
			elosztoUrl: '@',
			kategoria: '@',
			hatterSzin: '@',
			hirekSzama: '<',
			reszletes: '<',
			napokSzama: '<',
			elsoReszletes: '<'
		}
	}).name;

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	var pug = __webpack_require__(91);
	
	function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-newslist clearfix\" ng-class=\"{'only' : $ctrl.napokSzama, 'gray' : $ctrl.hatterSzin}\" ng-if=\"$ctrl.technikaiHiba || $ctrl.hirek.length\"\u003E\u003Cp class=\"technical-error\" ng-if=\"$ctrl.technikaiHiba\"\u003ETechnikai hiba történt!\u003C\u002Fp\u003E\u003Ch2 ng-if=\"$ctrl.hirdobozCim &amp;&amp; $ctrl.hirek.length\"\u003E{{ $ctrl.hirdobozCim }}\u003C\u002Fh2\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"col\" ng-repeat=\"hir in $ctrl.hirek\"\u003E\u003Cdiv class=\"image\"\u003E\u003Cimg ng-src=\"{{ hir.kiemeltKep }}\"\u003E\u003C\u002Fdiv\u003E\u003Ch3\u003E\u003Ca ng-href=\"{{$ctrl.getReszletesUrl(hir.id)}}\"\u003E{{ hir.cim }}\u003C\u002Fa\u003E\u003C\u002Fh3\u003E\u003Cp\u003E\u003Cspan class=\"date\"\u003E{{ hir.megjelenesDatuma | date : 'yyyy.MM.dd' }}\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cdiv ng-bind-html=\"hir.lead\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"btn btn-default\" ng-if=\"$ctrl.elosztoUrl\" ng-href=\"{{ $ctrl.elosztoUrl }}\"\u003ETovábbi hírek\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
	module.exports = template;

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MODULE_NAME = 'news';
	
	var NewsController = function () {
		NewsController.$inject = ["$document"];
		function NewsController($document) {
			'ngInject';
	
			_classCallCheck(this, NewsController);
	
			this._$document = $document;
		}
	
		_createClass(NewsController, [{
			key: '$onInit',
			value: function $onInit() {
				this.shareUrl = encodeURIComponent(this._$document[0].URL);
			}
		}]);
	
		return NewsController;
	}();
	
	angular.module(MODULE_NAME, []).controller('NewsController', NewsController);
	
	exports.default = MODULE_NAME;

/***/ })

});


// WEBPACK FOOTER //
// layouts/ANYI/layout.bundle.js